export const observer = {
  rootMargin: '100px',
};
